"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformanceObserver = exports.performance = void 0;
exports.performance = window.performance, exports.PerformanceObserver = window.PerformanceObserver;
